module.exports = __webpack_public_path__ + "img/show_cn_text_12.af341f74.png";